/**
 * The `internalType` values that mark the agenda structure inside an otherwise generic list document.
 *
 * The minutes are stored as plain ordered lists, so these attributes are the only thing telling the editor, the
 * exports and the regeneration splice which list is the agenda and which items are its entries.
 */

export const MINUTE_TREE_INTERNAL_TYPE = 'MinuteTree'
export const MINUTE_NODE_INTERNAL_TYPE = 'MinuteNode'
